export const getSafeValue = (value?: number | string) => value ?? "—";
